"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddBasketOffer = void 0;
var _addBasketOfferFailed = require("@ori-events/add-basket-offer-failed");
var _react = require("react");
var _contexts = require("../contexts");
var _logger = require("../logger");
var _utils = require("../utils");
const useAddBasketOffer = (offerId, onAddOfferFailedCallback) => {
  const {
    offersCount,
    setIsOfferHintsModalOpen,
    toggleConfirmationModal
  } = (0, _contexts.useCheckoutOfferHints)();
  const [isAdding, setIsAdding] = (0, _react.useState)(false);
  const isLastVisibleOffer = offersCount === 1;

  // success callback so far the same for all offers types,
  // so defined directly here for now
  const onAddOfferSuccessCallback = (0, _react.useCallback)(() => toggleConfirmationModal(true), [toggleConfirmationModal]);
  const addOfferHandler = (0, _react.useCallback)(async selectedItems => {
    (0, _logger.logDebug)(`Adding offer ${offerId} ...`);
    setIsAdding(true);
    toggleConfirmationModal(false);
    try {
      // response brings back basket-updated or add-basket-offer-failed data
      const response = await (0, _utils.addBasketOffer)(offerId, selectedItems);
      setIsAdding(false);
      if ((0, _addBasketOfferFailed.isAddBasketOfferErrorResponse)(response)) {
        onAddOfferFailedCallback(response);
      } else {
        // display confirmation
        onAddOfferSuccessCallback();
        if (isLastVisibleOffer) {
          setIsOfferHintsModalOpen(false);
        }
      }
    } catch (error) {
      setIsAdding(false);
      onAddOfferFailedCallback(undefined, error);
    }
  }, [offerId, toggleConfirmationModal, onAddOfferFailedCallback, onAddOfferSuccessCallback, isLastVisibleOffer, setIsOfferHintsModalOpen]);
  return {
    addOfferHandler,
    isAdding
  };
};
exports.useAddBasketOffer = useAddBasketOffer;